import { Box, Button, Paper, TextField } from "@mui/material";
import { instanceConfigMetadata } from "api";
import { initiateAXIOS } from "config/axios";
import { editSrgMetadata } from "externalFeatures/store/actions/smrt/srgLinesAction";
import {
  SET_ERROR_MESSAGE_SRGLINES_PAGE,
  SET_ERROR_PROMPT_SRGLINES_PAGE,
} from "externalFeatures/store/actionTypes/smrt/srgLinesActionType";
import { logger } from "helpers/logger";

import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { handleError } from "store/handleError";
import { handleTimeoutErrorPrompt } from "store/handlePrompt";

const SrgLinesFontSizeSelect = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation("srgLines");

  const sizeData = {
    largest: { size: "5", key: "sizexl", text: t("infoText.largestOpt") },
    large: { size: "4", key: "sizelg", text: t("infoText.largeOpt") },
    medium: { size: "3", key: "sizemd", text: t("infoText.mediumOpt") },
    small: { size: "2", key: "sizesm", text: t("infoText.smallOpt") },
    smallest: { size: "1", key: "sizexs", text: t("infoText.smallestOpt") },
  };

  const [savedValue, setSavedValue] = useState("1");
  const [selectedValue, setSelectedValue] = useState("1");
  const [isLoading, setIsLoading] = useState(false);

  const hasRun = useRef(false);

  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;
    getMetadata();

    //eslint-disable-next-line
  }, []);

  const getMetadata = async () => {
    setIsLoading(true);
    const access_token = sessionStorage.getItem("access_token");

    try {
      const { data } = await initiateAXIOS.get(instanceConfigMetadata, {
        headers: { authorization: `Bearer ${access_token}` },
      });

      setSavedValue("" + data.fontSize);
      setSelectedValue("" + data.fontSize);
    } catch (error) {
      const errorMessage = handleError(error);
      logger.error(errorMessage);
      dispatch({ type: SET_ERROR_PROMPT_SRGLINES_PAGE, payload: true });
      dispatch({
        type: SET_ERROR_MESSAGE_SRGLINES_PAGE,
        payload: errorMessage,
      });
      handleTimeoutErrorPrompt(dispatch, SET_ERROR_PROMPT_SRGLINES_PAGE);
    } finally {
      setIsLoading(false);
    }
  };

  const updateCallback = (type, payload = null) => {
    switch (type) {
      case "success":
        setSavedValue("" + payload.fontSize);
        break;

      default:
        break;
    }

    setIsLoading(false);
  };

  const handleUpdate = () => {
    logger.log("UPDATE");
    setIsLoading(true);
    dispatch(editSrgMetadata({ fontSize: +selectedValue }, updateCallback));
  };

  return (
    <Paper sx={{ mb: 2 }}>
      <Box sx={{ m: 1 }}>
        <TextField
          disabled={isLoading}
          size="small"
          label={"Info Text Size"}
          select
          SelectProps={{ native: true }}
          value={selectedValue}
          onChange={(e) => setSelectedValue(e.target.value)}
          sx={{ width: "180px" }}
        >
          {Object.values(sizeData).map((item) => (
            <option key={item.key} value={item.size}>
              {item.text}
            </option>
          ))}
        </TextField>
        <Button
          disabled={selectedValue === savedValue || isLoading}
          onClick={handleUpdate}
        >
          {t("infoText.updateBtn")}
        </Button>
      </Box>
    </Paper>
  );
};

export default SrgLinesFontSizeSelect;
